export default [
	{
		path: '/faqs',
		name: 'faqs',
		meta: {
			requiresAuth: true,
			section: 'faqs',
		},
		component: () => import('@/views/faq/Faq'),
	},
	{
		path: '/faqs/create',
		name: 'FaqsCreate',
		meta: {
			requiresAuth: true,
			section: 'faqs',
		},
		component: () => import('@/views/faq/FaqForm'),
	},
	{
		path: '/faqs/:id',
		name: 'FaqUpdate',
		meta: {
			requiresAuth: true,
			section: 'faqs',
		},
		component: () => import('@/views/faq/FaqForm'),
	},
]
